import { render, staticRenderFns } from "./urgence.vue?vue&type=template&id=b76e3252&scoped=true&"
import script from "./urgence.vue?vue&type=script&lang=js&"
export * from "./urgence.vue?vue&type=script&lang=js&"
import style0 from "./urgence.vue?vue&type=style&index=0&id=b76e3252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76e3252",
  null
  
)

export default component.exports